import React, { useEffect, createContext, useContext } from "react";
import Router from "next/router";
import { useDispatch, useSelector } from "react-redux";
import { closeCentralPaymentModal } from "../../store/actions/CentralPaymentActions"; 

const PostMessageContext = createContext();

export const PostMessageProvider = ({ children }) => {
    const dispatch = useDispatch();
    const useCentralPayment = useSelector(state => state.centralPaymentReducer.useCentralPayment);

    const closePopup = () => {
        console.log("Closing popup, useCentralPayment:", useCentralPayment);
        if (useCentralPayment) {
            dispatch(closeCentralPaymentModal());
        } else {
            Router.push("/");
        }
    };

    const handlePostMessage = (event) => {
        const { data } = event;
        if (!data) return;

        if (
            data.source === "react-devtools-content-script" ||
            data.source === "react-devtools-bridge" ||
            (typeof data === "object" && Object.prototype.hasOwnProperty.call(data, "payload"))
        ) {
            return;
        }

        console.log("[PostMessage] Received message:", data);

        switch (data.event) {
            case "goBackToMe":
                Router.push("/me/account-info/");
                break;
            case "goBackToWallet":
            case "closeIframe":
            case "closePopup":
            case "goBackToHome":
                closePopup();
                break;
            case "goToHistory":
                closePopup();
                Router.push("/transaction-record");
                break;
            case "goToHistoryW":
                closePopup();
                Router.push("/transaction-record");
                break;
            case "goToHistoryOther":
                closePopup();
                Router.push("/transaction-record");
                setTimeout(() => window.location.reload(), 1000);
                break;
            case "closeHistoryPage":
                Router.back();
                break;
            case "goUserInfo":
                closePopup();
                setTimeout(() => global.openProfilePopup?.(), 2000);
                break;
            case "goToKycPage":
                closePopup();
                Router.push("/me/upload-files/");
                break;
            case "NetworkError":
                closePopup();
                // setIsLogout();
                break;
            case "goToDeposit":
                closePopup();
                setTimeout(() => global.showDialog({ key: 'wallet:{"type": "deposit"}' }), 500);
                break;
            case "closeTutorialPage":
                Router.back();
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        window.addEventListener("message", handlePostMessage);
        return () => {
            window.removeEventListener("message", handlePostMessage);
        };
    }, []);

    return (
        <PostMessageContext.Provider value={handlePostMessage}>
            {children}
        </PostMessageContext.Provider>
    );
};

export const usePostMessage = () => useContext(PostMessageContext);
